import { connect } from "react-redux";
import { PageChangeYourPassword } from "senac-components";
import {
  ChangePasswordResult,
  PageChangeYourPasswordDispatchProps,
  PageChangeYourPasswordStateProps,
} from "senac-components/dist/pages/Mobile/PageChangeYourPassword";
import { PageChangeYourPasswordWeb } from "senac-components/dist/pages/Web/PageChangeYourPasswordWeb";
import { AppDispatch, RootState } from "../store";
import { commonSlice, contentSlice, userSlice } from "../store/reducers";
import {
  ContentHeaderOptionItem,
  MenuOptions,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { changePassword } from "../store/reducers/userSlice";

const mapState = (state: RootState) => {
  let result: PageChangeYourPasswordStateProps = {
    loading: state.userState.userAuthenticating,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageChangeYourPasswordDispatchProps = {
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: ContentHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToMyProfileOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) =>
      dispatch(commonSlice.actions.goToPage(option)),
    // onClickChangePassword: () => {},

    onClickChangePassword: (pass: ChangePasswordResult) => {
      if(pass.newPassword !== pass.repeatPassword) {
        dispatch(commonSlice.actions.showAlert({
          title : "Login",
          description : "Não foi possivel alterar a senha. A confirmação está diferente.",
          show:true
        }))

        return;
      }
      dispatch(
        changePassword({ password: pass.newPassword, currentPassword: pass.currentPassword, })
      )
    },

    // onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    // onClickRecoverPassword: (recoverPassword: string) =>
    //   dispatch(userSlice.actions.recoverPassword(recoverPassword)
    // )
  };

  return result;
};

const WPageChangeYourPassword = () => {
  const Component =
    window.innerWidth < 1024
      ? PageChangeYourPassword
      : PageChangeYourPasswordWeb;
  const Page = connect(mapState, mapDispatch)(Component);
  return <Page />;
};

export { WPageChangeYourPassword };
